
'use strict';

define('component!ModalComponent',['require','react','create-react-class','react-dom','underscore','mixins/ReflowMixin','mixins/TransitionMixin','lib/LayersEventManager','classnames'],function (require) {
  'use strict';

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var ReactDOM = require('react-dom');
  var _ = require('underscore');

  var ReflowMixin = require('mixins/ReflowMixin');
  var TransitionMixin = require('mixins/TransitionMixin');
  var LayersEventManager = require('lib/LayersEventManager');

  var cx = require('classnames');

  var ModalComponent = ReactCreateClass({
    displayName: 'ModalComponent',

    mixins: [ReflowMixin, TransitionMixin],

    getDefaultProps: function getDefaultProps() {
      return {
        isOpen: false,
        backdrop: true,
        showCloseButton: true,
        hideOnEsc: true,
        closeOnBackdropClick: true,
        className: '',

        onClose: undefined
      };
    },

    getInitialState: function getInitialState() {
      return {
        isOpen: false
      };
    },

    componentDidMount: function componentDidMount() {
      var _this = this;

      this._isMounted = true;
      this.reflow();
      this.setState({
        isOpen: this.props.isOpen,
        isMounted: true
      }, function () {
        if (_this.state.isOpen) {
          _this.updateModalStyles();
        }
      });
    },

    componentWillUnmount: function componentWillUnmount() {
      this._isMounted = false;
      this.removeBackdrop();
      if (this.state.isOpen) {
        LayersEventManager.unregister(this);
      }
    },

    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        this.setState({ isOpen: nextProps.isOpen });
      }
    },

    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isOpen !== this.state.isOpen) {
        if (this.state.isOpen) {
          LayersEventManager.register(this, 'keydown', this.handleKeyDownEvent);
        } else {
          LayersEventManager.unregister(this);
        }
      }
      this.updateModalStyles();
    },

    updateModalStyles: function updateModalStyles() {
      var _this2 = this;

      this.setInlineStyle();

      if (this.state.isOpen) {
        this.reflow();
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }

      if (this._isMounted) {
        this.onTransitionEnd(function () {
          _this2.setInlineStyle();
        }, 200);
      }
    },

    render: function render() {
      if (this.state.isOpen) {
        this.renderBackdrop();
      } else {
        this.removeBackdrop();
        return React.createElement('div', null);
      }

      var closeButtonStyle = {
        display: this.props.showCloseButton ? 'block' : 'none'
      };

      var classes = [this.props.className, cx({
        'modal-component': true,
        'fade': true,
        'in': this.state.isOpen
      })].join(' ');

      return React.createElement(
        'div',
        { className: classes, onClick: this.handleBackdropClick },
        React.createElement(
          'div',
          { className: 'modal-dialog', id: 'modal-dialog' },
          React.createElement('p', { className: 'close-button', id: 'close-button', onClick: this.close, style: closeButtonStyle }),
          this.props.children
        )
      );
    },

    handleKeyDownEvent: function handleKeyDownEvent(evt) {
      if (this._isMounted && this.state.isOpen && evt.keyCode === 27 && this.props.hideOnEsc) {
        this.close();
        evt.stopPropagation();
      }
    },

    setInlineStyle: function setInlineStyle() {
      if (this._isMounted) {
        if (this.state.isOpen) {
          ReactDOM.findDOMNode(this).style.display = 'block';
          ReactDOM.findDOMNode(this).style.visibility = 'visible';
        } else {
          ReactDOM.findDOMNode(this).style.display = 'none';
          ReactDOM.findDOMNode(this).style.visibility = 'hidden';
        }
      }
    },

    renderBackdrop: function renderBackdrop() {
      if (_.isElement(this.findBackdrop())) {
        return;
      }

      var node = document.createElement('div');
      node.className = 'modal-backdrop fade';

      document.body.appendChild(node);
      document.body.classList.add('modal-open');

      node.classList.add('in');
    },

    findBackdrop: function findBackdrop() {
      return document.body.querySelector('.modal-backdrop');
    },

    removeBackdrop: function removeBackdrop() {
      var node = this.findBackdrop();

      if (_.isElement(node)) {
        node.classList.remove('in');
        node.parentNode.removeChild(node);
      }

      document.body.classList.remove('modal-open');
    },

    open: function open() {
      this.setState({
        isOpen: true
      });
    },

    isOpen: function isOpen() {
      return this.state.isOpen;
    },

    close: function close() {
      this._isMounted = false;
      this.setState({
        isOpen: false,
        isMounted: false
      }, (function () {
        if (typeof this.props.onClose === 'function') {
          this.props.onClose();
        }
      }).bind(this));
    },

    handleBackdropClick: function handleBackdropClick(syntheticEvent) {
      if (syntheticEvent.target.classList.contains('modal-component')) {
        syntheticEvent.preventDefault();

        if (this.props.closeOnBackdropClick) {
          this.close();
        }
      }
    }
  });

  return ModalComponent;
});
